import Game from "../../Game.js";
export default class SpeedBar {
	constructor(mc, callback) {
		this.mc = mc;
		this.callback = callback;
		this.speed = 0;
		this.currentLen = 0;
	}

	init(speed, hasInitiative) {
		this.setSpeed(speed)
		jQuery(".js-turn-bar", this.mc).css("transform", "scaleX(0.01)");
		if (hasInitiative) {
			this.currentLen = 0.9;
		}
	}

	setSpeed(speed) {
		//speed = 1
		//for (let x = -14; x < 16; x++) {
		//console.log("-----")
		//speed = x;
		//console.log(speed)
		//this.speed = speed;
		//speed = -14
		if (speed > 15) {
			speed = 15;
		}
		if (speed < -14) {
			speed = -14;
		}
		let n = speed + 15;
		//console.log(n)
		// n: 30 = x : 100
		let perc = n / 29;
		// perc rispetto alla velocità massima 

		let d = SpeedBar.DISTANCE_IN_PIXEL;
		let t = SpeedBar.FASTER_TIME;
		let v = d / t;
		v = v * perc;
		let time = Math.floor(d / v);
		this.time = time;
		//v = d / time*100;
		//console.log(v)
		perc = 100 / time;
		this.speed = perc / SpeedBar.TIME_DIVIDER; // Game.GAME_FPS_LIMIT;
		//console.log(this.speed)
		/*			console.log(speed, time)
				}*/

	}

	dispatch(e) {
		if (this.callback) {
			this.callback.call(null, e);
		}
	}

	increment() {
		this.currentLen += this.speed;
		jQuery(".js-turn-bar", this.mc).css("transform", "scaleX(" + this.currentLen + ")");
		if (this.currentLen >= 1) {
			this.currentLen = 0;
			this.dispatch({ type: SpeedBar.EVENT_BAR_FULL })
		}
	}

}

SpeedBar.DISTANCE_IN_PIXEL = 50;
SpeedBar.FASTER_TIME = 1000;
SpeedBar.EVENT_BAR_FULL = "eventBarFull";
SpeedBar.TIME_DIVIDER = 2;